<template>
  <div v-if="type">
    <h1>Entity create</h1>
    <v-btn :to="navigate()" v-if="file">
      <v-icon>chevron_left</v-icon>Back to Entry Search
    </v-btn>
    <v-btn :to="navigateSearch()" v-if="!file">
      <v-icon>chevron_left</v-icon>
      Back to {{ type.name }} Search
    </v-btn>
    <FileWorking :file="file" v-if="file" />
    <h2>{{ type.name }}</h2>
    <v-alert :value="true" type="info"
      >Enter the name of the new entity. After clicking save you will be taken
      to the new entity so you can fill in more details</v-alert
    >
    <div v-if="type.company">
      <v-select
        :items="groups"
        v-model="entityCreate.groupid"
        item-value="id"
        item-text="name"
        label="Group"
        outline
        @change="updateName()"
        v-if="type.groups && groups"
      />
      <v-text-field label="Name" v-model="entityCreate.name" outline />
    </div>
    <div v-if="type.person">
      <v-select
        :items="titles"
        v-model="entityCreate.title"
        label="Title"
        outline
      />
      <v-text-field label="Forename" v-model="entityCreate.forename" outline />
      <v-text-field label="Surname" v-model="entityCreate.surname" outline />
    </div>
    <div v-if="related">
      <v-checkbox label v-model="copy">
        <template v-slot:label>
          <span>Copy to related file?&#160;</span>
          <FileZ :file="related" />
        </template>
      </v-checkbox>
    </div>
    <v-btn @click="createEntity"> <v-icon>save</v-icon>Save </v-btn>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import TITLES from "@/graphql/directory/Titles";
import FileZ from "@/components/link/FileZ";
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EntityCreate",
  metaInfo() {
    return {
      title: "Entity create",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileZ,
    FileWorking
  },
  apollo: {
    titles: {
      query: TITLES,
      context: { clientName: "open" },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    computedParams() {
      const relatedId = this.$route.query.relatedid
        ? this.$route.query.relatedid
        : undefined;
      return {
        objectType: "file",
        objectId: this.$route.query.fileid,
        relatedId
      };
    }
  },
  data() {
    return {
      type: null,
      groups: null,
      file: null,
      related: null,
      titles: null,
      copy: false,
      entityCreate: {
        relatedid: null,
        title: "Mr",
        forename: null,
        surname: null,
        name: null,
        groupid: null
      },
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async fetchType() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.type = response.data;
    },
    async fetchGroups() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/${this.$route.params.id}/groups`
      );
      // console.log(response.data);
      this.groups = response.data;
    },
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.query.fileid}`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchRelated() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.query.fileid}/related`
      );
      // console.log(response.data);
      this.related = response.data;
    },
    async createEntity() {
      try {
        const response = await nbmlaw.post(
          `/cors/admin/directory/types/${this.$route.params.id}/entities`,
          this.entityCreate
        );
        // console.log(response.data);
        this.$router.push({ name: "entity", params: { id: response.data } });
      } catch (err) {
        console.error(err);
        this.snackbar = true;
        this.snackbarText = err;
      }
    },
    navigate() {
      return {
        name: "entrySearch",
        params: {
          ...this.computedParams,
          typeId: this.type.id
        }
      };
    },
    navigateSearch() {
      if (this.type.company) {
        return { name: "searchCompany", params: { id: this.type.id } };
      } else if (this.type.person) {
        return { name: "searchIndividual", params: { id: this.type.id } };
      } else if (this.type.address == 2) {
        return { name: "searchProperty", params: { id: this.type.id } };
      }
      return null;
    },
    updateName() {
      this.entityCreate.name = this.entityCreate.groupid
        ? this.groups.find((g) => g.id == this.entityCreate.groupid).name
        : null;
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchType();
        this.fetchGroups();
      }
    },
    "$route.query.fileid": {
      immediate: true,
      handler() {
        this.entityCreate.fileid = this.$route.query.fileid
          ? Number(this.$route.query.fileid)
          : null;
        if (this.$route.query.fileid) {
          this.fetchFile();
          this.fetchRelated();
        }
      }
    },
    copy: {
      handler() {
        this.entityCreate.relatedid =
          this.related && this.copy ? this.related.id : null;
      }
    }
  }
};
</script>
